import { DriverInformationDto } from '@up/data';
import { BaseDto } from '../base.dto';

/**
 * Order Pickup DTO describes who and when has delivered the order.
 */
export class OrderPickUpDto extends BaseDto {
  /** Driver ID coming from the  Delivery Provider system. */
  driverId: number;

  /** Driver Info. */
  driver?: DriverInformationDto;

  /** Order ID. */
  orderId: number;

  /** Latitude - Geographical coordinates where driver delivered order. */
  latitude: number;

  /** Longitude - Geographical coordinates where driver delivered order. */
  longitude: number;

  /** When driver has pick up order from merchant. */
  pickupDateTime?: Date;

  /** Delivery date & time. */
  deliveredDateTime?: Date;
}
